import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './ImportantText.module.css';

type Props = {
  preset: 'text-1' | 'text-2' | 'text-3' | 'text-green-1';
  className?: string;
  children?: ReactNode;
};

export function ImportantText({ preset, className, children }: Props) {
  return (
    <span className={cx(styles.root, styles[`preset_${preset}`], className)}>
      {children}
    </span>
  );
}
